export default {
  methods: {
    getTabsData(defaultName) {
      const { idcId, cabinetId } = this.$route.query;

      return [{
        name: 'detail',
        label: this.$t('cabinet.resourceInformation'),
        disabled: false,
        route: {
          path: '/cabinet/detail',
          query: { idcId, cabinetId }
        },
        isDefault: defaultName === 'detail'
      }, {
        name: 'dynamic',
        label: this.$t('cabinet.dynamicInformation'),
        disabled: this.cabinetDetail && !this.cabinetDetail.showCurrent,
        route: {
          path: `/cabinet/dynamic`,
          query: { idcId, cabinetId }
        },
        isDefault: defaultName === 'dynamic'
      }];
    },
    jump_to_up() { // 机柜列表页面
      this.$router.push({
        path: '/cabinet/list/'
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/cabinetDetail/detail.mixin.js